import AgendamentoApi from '@/Apis/Agendamento/Services/AgendamentoApi'
import EventBus from '@/plugins/EventBus'
import Vue from 'vue'
import { HospitalByCurrentUser, UseHospitaisState } from './types'
import { RequestOptionsProps } from '../types'
import useLoading from '../useLoading'

// Cache em localStorage dos ids de hospitais do usuario, por sub, para que
// consumidores que nao podem fazer requests (ex.: plugin GetDemo) usem o dado
// da ultima vez que alguma tela o carregou. Evento avisa quem quiser reagir
// quando a lista chegar durante a sessao.
export const HOSPITAIS_CURRENT_USER_STORAGE_KEY = 'finx:hospitais-current-user'
export const HOSPITAIS_CURRENT_USER_LOADED_EVENT = 'hospitaisByCurrentUserLoaded'

function persistHospitaisIds(data: HospitalByCurrentUser[]) {
  try {
    const user: any = (Vue.prototype as any).$user
    const sub = user && user.profile && user.profile.sub
    if (!sub) return
    localStorage.setItem(HOSPITAIS_CURRENT_USER_STORAGE_KEY, JSON.stringify({
      sub,
      ids: data.map((h) => h.id),
    }))
  } catch (e) {
    // Cache e best-effort: sem storage disponivel, segue so com o estado em memoria.
  }
}

const useHospitais = (() => {
  const state = Vue.observable<UseHospitaisState>({
    fetchedHospitaisByCurrentUser: false,
    hospitaisByCurrentUser: [],
  })

  const { closeLoading, showLoading } = useLoading()

  function setHospitaisByCurrentUser(data: HospitalByCurrentUser[]) {
    state.hospitaisByCurrentUser = data
    persistHospitaisIds(data)
    EventBus.$emit(HOSPITAIS_CURRENT_USER_LOADED_EVENT, data)
  }

  // Zera o cache (em memoria e no localStorage) para forcar novo fetch na
  // proxima leitura. Necessario na personificacao: como a troca de usuario
  // ocorre por navegacao SPA (sem reload), o singleton continuaria servindo os
  // hospitais do operador em vez dos do usuario personificado.
  function reset() {
    state.fetchedHospitaisByCurrentUser = false
    state.hospitaisByCurrentUser = []
    try {
      localStorage.removeItem(HOSPITAIS_CURRENT_USER_STORAGE_KEY)
    } catch (e) {
      // best-effort
    }
  }

  async function loadHospitaisByCurrentUser({
    showLoading: shouldShowLoading = true,
    forceRefresh = false,
    showToastError = true,
  }: RequestOptionsProps = {}) {
    if (state.fetchedHospitaisByCurrentUser && !forceRefresh) {
      return { success: true, data: state.hospitaisByCurrentUser }
    }
    if (shouldShowLoading) showLoading()
    const response = await AgendamentoApi.getHospitalCurrentUser()
    if (response.success) {
      setHospitaisByCurrentUser(response.data)
      state.fetchedHospitaisByCurrentUser = true
    } else if (showToastError) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'Ocorreu um erro na requisição.',
        icon: 'warning',
        color: '#C62828',
      })
    }
    closeLoading()
    return response
  }

  return {
    get hospitaisByCurrentUser() {
      return state.hospitaisByCurrentUser
    },
    loadHospitaisByCurrentUser,
    setHospitaisByCurrentUser,
    reset,
  }
})()

export default useHospitais
